var specList = document.querySelector('.cm-specifications__list')

if (specList) {
    var specTrigger = document.querySelector('.js-specifications-trigger')

    specTrigger.addEventListener('click', function () {
        if (specList.classList.contains('_is-open')) {
            specList.classList.remove('_is-open');
            specTrigger.innerHTML = "Read More";
        } else {
            specList.classList.add('_is-open');
            specTrigger.innerHTML = "Read Less";
        }
    })
}
